import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × RIMOWA: Aerospace minimalism
// Metallic ribs, aerodynamic arcs, travel patterns
export function VasarelyRimowaMode({ brand }: ModeRendererProps) {
  const rimowaGray = "#A0A0A0";

  return (
    <g>
      {/* Aluminum background */}
      <defs>
        <linearGradient id="rimowa-aluminum" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#D0D0D0" />
          <stop offset="50%" stopColor="#B8B8B8" />
          <stop offset="100%" stopColor="#D0D0D0" />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#rimowa-aluminum)" />

      <g transform="translate(397 540)">
        {/* Metallic ribs (grooved pattern) */}
        {Array.from({ length: 32 }).map((_, i) => {
          const y = -320 + i * 20;
          
          return (
            <g key={i}>
              <line
                x1="-320"
                y1={y}
                x2="320"
                y2={y}
                stroke="#999"
                strokeWidth="3"
                opacity="0.6"
              />
              <line
                x1="-320"
                y1={y + 2}
                x2="320"
                y2={y + 2}
                stroke="#CCC"
                strokeWidth="1"
                opacity="0.4"
              />
            </g>
          );
        })}

        {/* Aerodynamic arcs */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 180;
          
          return (
            <ellipse
              key={angle}
              cx={Math.cos(rad) * r}
              cy={Math.sin(rad) * r}
              rx="50"
              ry="70"
              fill="none"
              stroke={rimowaGray}
              strokeWidth="3"
              opacity="0.5"
              transform={`rotate(${angle} ${Math.cos(rad) * r} ${Math.sin(rad) * r})`}
            />
          );
        })}

        {/* Travel pattern grid */}
        {Array.from({ length: 16 }).map((_, i) => {
          const angle = (i * Math.PI) / 8;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 240}
              y2={Math.sin(angle) * 240}
              stroke={rimowaGray}
              strokeWidth="1"
              opacity="0.25"
            />
          );
        })}

        {/* Engineered circles */}
        {Array.from({ length: 14 }).map((_, i) => {
          const r = 50 + i * 16;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={rimowaGray}
              strokeWidth="1.5"
              opacity={0.3 - i * 0.016}
            />
          );
        })}

        {/* Trust nodes (corners) */}
        {[
          { x: -180, y: -140 },
          { x: 180, y: -140 },
          { x: -180, y: 140 },
          { x: 180, y: 140 },
        ].map((corner, i) => (
          <g key={i}>
            <rect
              x={corner.x - 20}
              y={corner.y - 20}
              width="40"
              height="40"
              fill={rimowaGray}
              opacity="0.5"
              rx="4"
            />
            <rect
              x={corner.x - 20}
              y={corner.y - 20}
              width="40"
              height="40"
              fill="none"
              stroke="#666"
              strokeWidth="2"
              opacity="0.7"
              rx="4"
            />
          </g>
        ))}

        {/* Central handle (design signature) */}
        <rect x="-80" y="-20" width="160" height="40" fill="none" stroke={rimowaGray} strokeWidth="4" opacity="0.7" rx="20" />
        <rect x="-70" y="-15" width="140" height="30" fill={brand.white} opacity="0.3" rx="15" />
        
        {/* Rivet details */}
        {[-60, -20, 20, 60].map((x) => (
          <circle
            key={x}
            cx={x}
            cy="0"
            r="5"
            fill="#888"
            opacity="0.8"
          />
        ))}
      </g>

      {/* Rimowa text */}
      <text x="397" y="1025" textAnchor="middle" fontFamily="sans-serif" fontWeight="600" fontSize="12" fill="#666" opacity="0.8">
        MINIMALISME AÉROSPATIAL
      </text>
    </g>
  );
}
